import React, { useState, useRef, useEffect } from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import './TextLanguageSwitcher.css';

const TextLanguageSwitcher = () => {
  const { currentLanguage, changeLanguage } = useLanguage();
  const { translations: tRaw } = useLanguage();
  const t = tRaw?.languageSwitcher || {};
  
  const [isOpen, setIsOpen] = useState(false);
  const switcherRef = useRef(null);

  const languageNames = {
    en: t?.english || "English",
    fr: t?.french || "Français",
    ar: t?.arabic || "العربية",
    ur: t?.urdu || "اردو"
  };

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
  };

  const handleLanguageChange = (lang) => {
    if (lang !== currentLanguage) {
      changeLanguage(lang);
    }
    setIsOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (switcherRef.current && !switcherRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="text-language-switcher" ref={switcherRef}>
      <button className="language-button" onClick={toggleDropdown}>
        {languageNames[currentLanguage] || t?.defaultLanguage || "Language"}
      </button>

      {isOpen && (
        <ul className="text-language-dropdown">
          {Object.entries(languageNames).map(([lang, name]) => (
            <li
              key={lang}
              className={lang === currentLanguage ? "menu-active" : ""}
              onClick={() => handleLanguageChange(lang)}
            >
              {name}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default TextLanguageSwitcher;